import React from 'react';
import i18n from '../../../i18n';
import { useSelector } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { makeStyles } from '@material-ui/core/styles';
import { string } from 'yup';

import { useFormError, validator } from 'core/form/form';

import { isUIEnabledSelector } from 'state/app/selectors';

import { FormErrorMessage } from 'components/FormErrorMessage/FormErrorMessage';
import { LargeButton, LargeButtonColor } from 'components/LargeButton/LargeButton';
import { MobilePhoneControlField } from 'components/MobilePhoneControl/MobilePhoneControl';
import { PasswordControlField } from 'components/PasswordControl/PasswordControl';
import { RoundCheckboxControlField } from 'components/RoundCheckbox/RoundCheckbox';

import { Form } from 'forms/types';

const useStyles = makeStyles(theme => ({
    field: {
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down(360)]: {
            marginBottom: theme.spacing(1.5),
        },
    },
    selectRole: {
        marginBottom: theme.spacing(4),
        [theme.breakpoints.down(360)]: {
            marginBottom: theme.spacing(2),
        },
    },
    loginButton: {
        marginTop: theme.spacing(6.5),
        [theme.breakpoints.down(360)]: {
            marginTop: theme.spacing(2.5),
        },
    },
}));

export const LoginForm = reduxForm({
    form: Form.LOGIN_FORM,
    initialValues: { phone: '', password: '', isVendor: false },
    validate: validator({
        phone: string().required('common:validation.required'),
        password: string().required('common:validation.required'),
    }),
})(props => {
    const { handleSubmit } = props;
    const isUIEnabled = useSelector(isUIEnabledSelector);
    const { t } = i18n.useTranslation();
    const error = useFormError(Form.LOGIN_FORM);
    const classes = useStyles();
    return (
        <form onSubmit={handleSubmit}>
            <div className={classes.field}>
                <Field name="phone" component={MobilePhoneControlField} label={t('auth:login.phone')} />
            </div>
            <div className={classes.field}>
                <Field name="password" component={PasswordControlField} label={t('auth:login.password')} />
            </div>
            {error && (
                <div className={classes.field}>
                    <FormErrorMessage error={error} />
                </div>
            )}
            <div className={classes.loginButton}>
                <LargeButton color={LargeButtonColor.SUCCESS} disabled={!!error || !isUIEnabled} type="submit">
                    {t('auth:login.loginButton')}
                </LargeButton>
            </div>
        </form>
    );
});
